<div (cdkObserveContent)="onContentChange($event)">
  <ng-content></ng-content>
</div>
